import { render } from "./UniqueBlock.vue?vue&type=template&id=6ce65229&scoped=true"
const script = {}

import "./UniqueBlock.vue?vue&type=style&index=0&id=6ce65229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce65229"]])

export default __exports__